import "core-js/modules/es.array.push.js";
import UserService from '@/services/UserService';
import Login from '@/components/Login';
import ContactModal from '@/components/modals/ContactModal';
import SearchModal from '@/components/modals/SearchModal';
import { bus } from '@/eventBus';
export default {
  name: 'Navigation',
  components: {
    ContactModal,
    SearchModal,
    Login
  },
  data() {
    return {
      networkInfo: null,
      userInfo: null,
      searchText: '',
      showLoginModal: false
    };
  },
  async mounted() {
    await this.getNetworkInfo();
    await this.getUserInfo();
    bus.$on('loggedIn', () => {
      this.getUserInfo();
    });

    // Other pages (e.g. the "search before you subscribe" box on the home
    // page) can ask the navigation to open the public search modal.
    bus.$on('openNetworkSearch', query => {
      this.searchText = query || '';
      this.openSearchModal();
    });
  },
  beforeUnmount() {
    bus.$off('openNetworkSearch');
  },
  computed: {
    isLoggedIn() {
      return this.userInfo && this.userInfo.user_id > 0;
    },
    brandImage() {
      if (!this.networkInfo) return null;
      return this.networkInfo.profileimage_display || this.networkInfo.logoimage_display || null;
    }
  },
  methods: {
    async getNetworkInfo() {
      this.networkInfo = await UserService.getNetworkInfo();
    },
    async getUserInfo() {
      this.userInfo = await UserService.getUserInfo();
    },
    // BVN's BNavForm always preventDefault()s submit, so the native GET to /video no longer
    // happens on its own; do the same full navigation the browser used to do.
    searchVideos() {
      window.location.assign('/video?text_search=' + encodeURIComponent(this.searchText.trim()));
    },
    openSearchModal() {
      if (this.searchText.trim().length && this.$refs.searchModal) {
        this.$refs.searchModal.open(this.searchText);
      }
    },
    async logout() {
      localStorage.clear();
      await this.getUserInfo();
      bus.$emit('loggedOut');
      this.$nextTick(() => {
        this.$router.push('/');
      });
    }
  }
};